import jQuery from "jquery";
import {ZIDX, ZIDXPage} from "../standaloneLibrary.js";

let $=jQuery.noConflict();
export class ZIDXSavedSearches implements ZIDXPage{
    zidx:ZIDX;
    constructor(zidx:ZIDX) {
        this.zidx = zidx;
    }
    getPageClass(){
        return "zidxSavedSearchesContainer";
    }
    render(){
        // let listView=new ZIDXAccountListView();
        // listView.render();
        let email=localStorage.getItem("zidx.email");
        if(email && email!=="") {

            let self = this;
            let obj = {
                id: "ajaxSavedSearchLoad",
                method: "get",
                // postObj: postObj,
                ignoreOldRequests: true,
                callback: function (r: string) {
                    // console.log(r);
                    let rs = JSON.parse(r);
                    if (rs.success) {
                        // console.log("loaded saved searches", rs.data);
                        $("#AccountSavedSearchesContainer", $(".zidxSavedSearchesContainer", self.zidx.peakidxShadowRoot)).html(rs.data);

                        $(".zidxSavedSearchDeleteLink", self.zidx.peakidxShadowRoot).on("click", function (this: HTMLAnchorElement, e: any) {
                            e.preventDefault();
                            let name = $(this).attr("data-name");
                            let parentId = $(this).attr("data-parent-id");
                            if (window.confirm("Are you sure you want to delete this " + name + "?")) {
                                let obj = {
                                    id: "ajaxSavedSearchDelete",
                                    method: "get",
                                    // postObj: postObj,
                                    ignoreOldRequests: true,
                                    callback: function (r: string) {
                                        let rs = JSON.parse(r);
                                        if (rs.success) {
                                            $("#" + parentId, self.zidx.peakidxShadowRoot).remove();
                                        } else {
                                            alert("Unable to delete saved search, please try again later");
                                        }
                                    },
                                    errorCallback: function (r: string) {
                                        alert("There was a temporary network problem, please try again later");
                                    },
                                    url: this.href
                                };
                                self.zidx.ajaxRequest(obj);

                            }
                        });
                        // }else{
                        //     alert("Unable to load saved search, please try again later");
                    }else{
                        $("#AccountSavedSearchesContainer", $(".zidxSavedSearchesContainer", self.zidx.peakidxShadowRoot)).text(rs.errorMessage || "Please log in to view your saved searches.");
                    }
                },
                errorCallback: function (r: string) {
                    alert("There was a temporary network problem, please try again later");
                },
                url: self.zidx.options.siteDomain + "/load-saved-searches/?email=" + email
            };
            self.zidx.ajaxRequest(obj);
        }else{

            $("#AccountSavedSearchesContainer", $(".zidxSavedSearchesContainer", this.zidx.peakidxShadowRoot)).html("You have no saved searches.");
        }
    }
}